const benefits = [
  {
    num: '01',
    title: 'Authorized Access',
    body: 'Direct, verified access to the complete NanoPro® product lineup as an authorized reseller with confirmed supply chain integrity.',
    icon: 'ri-verified-badge-fill',
  },
  {
    num: '02',
    title: 'Expert Coating Guidance',
    body: 'Identify the correct NanoPro® formulation for your exact application and performance requirements — without guesswork.',
    icon: 'ri-search-eye-line',
  },
  {
    num: '03',
    title: 'Professional-Grade Only',
    body: 'ASTM-approved, CARFAX-registerable formulations for professional-level permanence — no consumer shortcuts, no diluted formulas.',
    icon: 'ri-award-fill',
  },
  {
    num: '04',
    title: 'Multi-Industry Supply',
    body: 'Automotive to marine, aviation to residential — sourcing across the full NanoPro® market spectrum for any surface type.',
    icon: 'ri-global-line',
  },
  {
    num: '05',
    title: 'Direct Inquiry Support',
    body: 'Reach us directly for product details, availability checks, dealer purchasing assistance, and technical coating questions.',
    icon: 'ri-message-3-line',
  },
  {
    num: '06',
    title: 'U.S. Manufactured Products',
    body: 'All NanoPro® formulations are engineered and manufactured in-house at the corporate facility in West Palm Beach, Florida.',
    icon: 'ri-map-pin-2-fill',
  },
];

const scrollToContact = () => {
  const el = document.getElementById('contact');
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
};

const WhyChooseSection = () => (
  <section id="why-choose" className="bg-[#060606] py-24 lg:py-32 border-t border-white/5">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-14">

      {/* ── Header ── */}
      <div className="grid lg:grid-cols-2 gap-12 items-end mb-16">
        <div>
          <div className="flex items-center gap-4 mb-5">
            <div className="h-px w-10 bg-[#c9a84c]" />
            <p className="text-[#c9a84c] text-[10px] tracking-[0.32em] font-black">RESELLER ADVANTAGE</p>
          </div>
          <h2
            className="text-white font-black leading-[0.95]"
            style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(34px, 4.8vw, 60px)', letterSpacing: '-0.03em' }}
          >
            Why Choose<br />
            <span className="text-gold-gradient">Surface Solutions of CT</span>
          </h2>
        </div>
        <div>
          <p className="text-white/38 text-[15px] leading-[1.9] mb-6">
            Not a store — a product sourcing partner and expert advisor. Whether you need one bottle or a full supply order, Surface Solutions of CT provides authorized access with professional guidance.
          </p>
          <div className="flex items-center gap-4">
            <div className="w-px h-10 bg-[#c9a84c]/30" />
            <p className="text-white/22 text-[11px] leading-relaxed">
              All NanoPro® products available through Surface Solutions of CT — your direct line to the manufacturer's authorized distribution.
            </p>
          </div>
        </div>
      </div>

      {/* ── Benefits grid ── */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
        {benefits.map((b) => (
          <div
            key={b.num}
            className="bg-[#060606] p-8 group hover:bg-[#0c0c0c] transition-colors duration-300 relative overflow-hidden"
          >
            <span
              className="absolute -top-4 right-3 font-black text-white/[0.03] select-none leading-none pointer-events-none"
              style={{ fontSize: '96px', fontFamily: "'Space Grotesk', sans-serif" }}
            >
              {b.num}
            </span>

            <div className="flex items-start gap-5 mb-5">
              <div className="w-9 h-9 flex items-center justify-center border border-[#c9a84c]/20 flex-shrink-0 mt-0.5">
                <i className={`${b.icon} text-[#c9a84c] text-[15px]`} />
              </div>
              <div>
                <span className="block text-[#c9a84c] text-[10px] tracking-[0.22em] font-black mb-1">{b.num}</span>
                <h3
                  className="text-white font-bold leading-snug"
                  style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(14px, 1.2vw, 16px)' }}
                >
                  {b.title}
                </h3>
              </div>
            </div>
            <p className="text-white/38 text-[13px] leading-[1.85]">{b.body}</p>
            <div className="mt-7 h-px w-5 bg-[#c9a84c]/30 group-hover:w-12 transition-all duration-400" />
          </div>
        ))}
      </div>

      {/* ── CTA bar ── */}
      <div className="mt-0 flex flex-col sm:flex-row items-center justify-between gap-6 border border-t-0 border-white/5 px-8 py-6 bg-[#0a0a0a]">
        <p className="text-white/30 text-[13px]">
          Ready to inquire about product availability or get help choosing the right coating?
        </p>
        <button
          onClick={scrollToContact}
          className="flex-shrink-0 px-9 py-4 bg-[#c9a84c] text-[#030303] text-[11px] font-black tracking-[0.18em] hover:bg-[#e0bf6a] transition-colors cursor-pointer whitespace-nowrap"
        >
          SPEAK WITH SURFACE SOLUTIONS OF CT
        </button>
      </div>
    </div>
  </section>
);

export default WhyChooseSection;
